import { Component, Input } from '@angular/core';

import { FirebaseService } from '../../services/firebase.service';

import { ScaleOptions } from '../../dictionaries';

import * as _ from 'lodash';

@Component({
  selector    : 'scale-recipe',
  templateUrl : 'scale-recipe.html',
  styleUrls   : [ 'scale-recipe.scss' ]
})

export class scaleRecipeComponent {
  @Input() group;

  id           : string   = _.uniqueId('scale_');
  scaleOptions : object[] = ScaleOptions;
  currentScale : number   = 1;

  constructor(
    private firebaseService : FirebaseService
  ) {
    this.initCurrentScale();
  }

  initCurrentScale(counter : number = 0) : void {
    if (this.group && this.group[0]) {
      if (this.group[0].scale)
        this.currentScale = this.group[0].scale;
    } else if (counter++ < 100) {
      setTimeout(() => this.initCurrentScale(counter), 10);
    }
  }

  scaleRecipe(event) {
    this.firebaseService.scaleRecipe(parseFloat(event.target.value), this.group);
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/scale-recipe/scale-recipe.ts